import {Col, Container, Modal, Row} from "react-bootstrap";
import React, {useState} from "react";
import {Controller, useForm, useWatch} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import IconButton from "@mui/material/IconButton";
import {formatDate} from "../common/Utils";
import {saveCompanyDiscountCodeTokens} from "../common/api/WebApi";

export default function ManageDiscountCodeTokensModal({discountCode, show, saving, handleClose, handleSave}) {

  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      discountCodeTokens:
        discountCode?.discountCodeTokens?.map((token) => ({
          ...token,
          codeToken: token.codeToken ?? "",
          deleted: token.deleted ?? false,
        })) ?? [],
    },
  });

  const tokens = useWatch({
    control,
    name: "discountCodeTokens",
  });

  const onSubmit = (data) => {
    discountCode.discountCodeTokens = data.discountCodeTokens;
    saveCompanyDiscountCodeTokens(discountCode).then((result)=> {
      handleSave(data);
    });
  };

  const [errorMessage, setErrorMessage] = useState(null);

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(onSubmit)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Edit {discountCode?.name} Tokens</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>

                <table className={'table table-striped'}>
                  <thead>
                  <tr>
                    <th>
                      Delete
                    </th>
                    <th>
                      Token
                    </th>
                    <th>
                      Usage Date
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {tokens?.map((token, idx) => {
                    return (<tr key={idx} className={'my-2'}>
                      <td className={'col'} xs={2}>
                        <IconButton
                          type="button"
                          disabled={token?.usageDate != null}
                          aria-label={token.deleted ? "Restore code" : "Delete code"}
                          onClick={() => {
                            setValue(
                              `discountCodeTokens.${idx}.deleted`,
                              !token.deleted,
                              {shouldDirty: true}
                            );
                          }}
                        >
                          {token.deleted ? (
                            <RestoreFromTrashIcon/>
                          ) : (
                            <DeleteOutlineIcon/>
                          )}
                        </IconButton>
                      </td>
                      <td className={'col'} sm={6} xs={6}>
                        <div className="form-group">
                          <div
                            style={{
                              opacity: token.deleted ? 0.5 : 1,
                            }}
                          >
                            <Controller
                              name={`discountCodeTokens.${idx}.codeToken`}
                              control={control}
                              rules={{
                                required: "Discount code is required",
                                validate: (value) =>
                                  value.trim().length > 0 || "Discount code is required",
                              }}
                              render={({field, fieldState}) => (
                                <MDInput
                                  {...field}
                                  label={`Discount Code ${idx + 1}`}
                                  value={field.value ?? ""}
                                  required
                                  disabled={token.deleted || token.usageDate != null}
                                  error={!!fieldState.error}
                                  helperText={fieldState.error?.message}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </td>
                      <td className={'col'} sm={4} xs={12}>
                        {token?.usageDate && formatDate(token?.usageDate)}
                      </td>
                    </tr>)
                  })}
                  </tbody>
                </table>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}